import React from 'react';
import { Helmet } from 'react-helmet';
import {
  Card,
  CardBody,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Nav,
  NavItem,
  NavLink,
  Row,
  Table,
  UncontrolledDropdown,
  Breadcrumb,
  BreadcrumbItem,
  TabPane,
  TabContent
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as actions from '@src/store/actions';
import { Link } from 'react-router-dom';
import connect from 'react-redux/es/connect/connect';
import AddressHelper from '@src/components/Elements/AddressHelper/AddressHelper';
import DeveloperModal from '../DeveloperModal/DeveloperModal';
import classnames from 'classnames';
import Activities from '@components/Elements/Activites/Activities';
import ProgressBox from '@src/components/ProgressBox/ProgressBox';
import Auth from '@src/components/Elements/Auth/Auth';

class DeveloperView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modalActive: false,
      activeTab: '1'
    };

    if (
      props.entity.id === undefined ||
      props.entity.id !== parseInt(props.id, 10)
    ) {
      props.getEntity(props.id);
    }
  }

  toggle = modalType => {
    this.setState(prevState => ({
      [modalType]: !prevState[modalType]
    }));
  };

  render = () => {
    const { entity } = this.props;
    return (
      <Container>
        <Helmet>
          <title>NXT Insurance Hub | Developers</title>
        </Helmet>
        {entity.id !== undefined &&
          this.props.entity.id === parseInt(this.props.id, 10) && (
            <React.Fragment>
              {this.props.loading && (
                <ProgressBox text={'Loading ...'} loader={'blue-background'} />
              )}
              <div>
                <Breadcrumb className={'pt-0'} listClassName={'pt-0 pl-0'}>
                  <BreadcrumbItem>
                    <Link to={'/developers'}>Developers</Link>
                  </BreadcrumbItem>
                  <BreadcrumbItem active>{entity.name}</BreadcrumbItem>
                </Breadcrumb>
              </div>
              <Row>
                <Col>
                  <div className={'float-left mr-3'}>
                    <FontAwesomeIcon
                      icon={['fas', 'home']}
                      className={'fa-3x color-blue'}
                    />
                  </div>
                  <div className={'color-blue font-md float-left text-break'}>
                    {entity.name}
                    <div className={'color-blue font-sm'}>Developer</div>
                  </div>
                  <Auth action={'Developers::edit'}>
                    <div className={'float-right'}>
                      <UncontrolledDropdown>
                        <DropdownToggle caret>Actions</DropdownToggle>
                        <DropdownMenu right>
                          <DropdownItem
                            onClick={() => this.toggle('modalActive')}
                          >
                            Edit Details
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </Auth>
                </Col>
              </Row>
              <Row className={'mt-3'}>
                <Col>
                  <Card>
                    <CardBody>
                      <div className={'pb-3'}>
                        <Table size={'sm'} borderless>
                          <tbody>
                            <tr>
                              <th width={'20%'}>Contact Person</th>
                              <td>{entity.contact_name}</td>
                            </tr>
                            <tr>
                              <th>Email</th>
                              <td>{entity.email}</td>
                            </tr>
                            <tr>
                              <th>Phone Number</th>
                              <td>{entity.phone}</td>
                            </tr>
                            <tr>
                              <th>Fax</th>
                              <td>{entity.fax}</td>
                            </tr>
                            <tr>
                              <th>Address</th>
                              <td>
                                <AddressHelper {...entity} />
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>

                      <Row className={'pb-5'}>
                        <Col>
                          <Nav tabs>
                            <NavItem>
                              <NavLink
                                className={classnames({
                                  active: this.state.activeTab === '1',
                                  pointer: true
                                })}
                              >
                                History
                              </NavLink>
                            </NavItem>
                          </Nav>

                          <TabContent activeTab={this.state.activeTab}>
                            <TabPane tabId="1">
                              <div
                                className={
                                  'p-3 border-left border-right border-bottom'
                                }
                              >
                                <Activities activities={entity.activities} />
                              </div>
                            </TabPane>
                          </TabContent>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <DeveloperModal
                entity={this.props.entity}
                history={this.props.history}
                isActive={this.state.modalActive}
                toggle={() => this.toggle('modalActive')}
              />
            </React.Fragment>
          )}
      </Container>
    );
  };
}

const mapStateToProps = state => {
  return {
    entity: state.developer.viewItem,
    loading: state.developer.loading
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getEntity: entityId => dispatch(actions.getDeveloper(entityId))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DeveloperView);
